import React from 'react';
import { connect } from 'react-redux';
import RetailersMenu from '../../components/menus/RetailersMenu';

const findUserRetailerCart = (cartsData, userId, retailerId) => {
  const cartData = cartsData.find((cart) => cart.user_id === userId && cart.retailer_id === retailerId);
  return cartData ? Object.values(cartData.variants) : [];
};

function RetailerMenuContainer(props) {
  return <RetailersMenu {...props} />;
}

const mapStateToProps = (state) => {
  const {
    role: { user, retailer },
    cart: { cartsData },
  } = state;
  let cartVariantsCount = 0;

  if (user && retailer) {
    const variants = findUserRetailerCart(cartsData, user.id, retailer.id);
    cartVariantsCount = variants.reduce((sum, quantity) => sum + quantity, 0);
  }

  return {
    cartVariantsCount,
  };
};

export default connect(mapStateToProps, null)(RetailerMenuContainer);
